import numbro from 'numbro';

const currencyMap = {
  EUR: '€',
  NOK: 'NOK'
};

export const formatCurrency = (value, currency) =>
  `${numbro(value).format('0.[00]')} ${currencyMap[currency]}`;



// WEBPACK FOOTER //
// ./src/helpers/format.js